import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Form, Modal, Row } from "antd";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnCard from "../common/adnCard/AdnCard";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnInput from "../common/adnInput/AdnInput";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import "./EmployeeAwardsListForm.css";

const EmployeeAwardsListForm = ({
  title,
  loading,
  months,
  years,
  columns,
  employees,
  employeeList,
  totalRecords,
  currentPage,
  referencedByList,
  handleOrderList,
  handleChangePage,
  handleSearchEmployee,
  handleSelectEmployee,
  handleSearchReferencedBy,
  handleSelectReferencedBy,
  handlePaymentChange,
  handleStatusChange,
  handleMonthChange,
  handleYearChange,
  cancelModalVisible,
  setCancelModalVisible,
  editModalVisible,
  setEditModalVisible,
  form,
  handleCancelFinish,
  handleEditFinish,
  initValues,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row className="filter-group" gutter={16}>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
          >
            <AdnAutoComplete
              placeholder={t("employeeAwards.form.placeholders.employeeName")}
              handleSearch={handleSearchEmployee}
              handleSelect={handleSelectEmployee}
              resultList={employeeList}
              valueId="name"
              allowClear={true}
            />
          </Col>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
          >
            <AdnAutoComplete
              placeholder={t(
                "employeeAwards.form.placeholders.referencedByName"
              )}
              handleSearch={handleSearchReferencedBy}
              handleSelect={handleSelectReferencedBy}
              resultList={referencedByList}
              valueId="name"
              allowClear={true}
            />
          </Col>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
          >
            <AdnDropdown
              placeholder={t("employeeAwards.form.placeholders.payment")}
              handleChange={(value) => handlePaymentChange(value)}
              options={[
                { id: "1", name: t("employeeAwards.payment.firstPayment") },
                { id: "2", name: t("employeeAwards.payment.secondPayment") },
              ]}
              allowClear={true}
            />
          </Col>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
          >
            <AdnDropdown
              placeholder={t("employeeAwards.form.placeholders.paymentStatus")}
              handleChange={(value) => handleStatusChange(value)}
              defaultValue={t("employeeAwards.status.notPaid")}
              options={[
                { id: "0", name: t("employeeAwards.status.notPaid") },
                { id: "1", name: t("employeeAwards.status.paid") },
                { id: "2", name: t("employeeAwards.status.canceled") },
              ]}
              allowClear={true}
            />
          </Col>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
          >
            <AdnDropdown
              placeholder={t("employeeAwards.form.placeholders.month")}
              handleChange={(value) => handleMonthChange(value)}
              options={months}
              allowClear={true}
            />
          </Col>
          <Col
            className="filter-item"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
          >
            <AdnDropdown
              placeholder={t("employeeAwards.form.placeholders.year")}
              handleChange={(value) => handleYearChange(value)}
              options={years}
              allowClear={true}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <AdnTable
              className={"benefitList"}
              columns={columns}
              data={employees}
              currentPage={currentPage}
              handleChange={handleOrderList}
              handleChangePage={handleChangePage}
              totalRecords={totalRecords}
              expandable={(record) => (
                <p style={{ margin: 0 }}>
                  <b>{t("employeeAwards.form.labels.notes")} </b> {record.notes}
                </p>
              )}
            />
          </Col>
        </Row>
        <Modal
          title={t("employeeAwards.form.modals.cancelRecommendationBenefit")}
          open={cancelModalVisible}
          onOk={form.submit}
          okText={t("employeeAwards.form.buttons.cancelBenefit")}
          onCancel={() => {
            setCancelModalVisible(false);
            form.resetFields();
          }}
          cancelText={t("employeeAwards.form.buttons.back")}
        >
          <Form
            form={form}
            name="form_in_modal"
            layout="vertical"
            onFinish={handleCancelFinish}
            initialValues={initValues}
          >
            <p> {t("employeeAwards.form.confirmations.cancelAward")} </p>
            <p> {t("employeeAwards.form.confirmations.writeNotes")} </p>
            <AdnInput
              name={"notes"}
              placeholder={t("employeeAwards.form.placeholders.insertNotes")}
              maxLength={500}
            />
          </Form>
        </Modal>
        <Modal
          title={t("employeeAwards.form.modals.editRecommendationBenefit")}
          open={editModalVisible}
          onOk={form.submit}
          okText={t("employeeAwards.form.buttons.saveBenefit")}
          onCancel={() => {
            setEditModalVisible(false);
            form.resetFields();
          }}
          cancelText={t("employeeAwards.form.buttons.back")}
        >
          <Form
            form={form}
            name="form_in_modal"
            layout="vertical"
            onFinish={handleEditFinish}
            initialValues={initValues}
          >
            <AdnInput
              name={"notes"}
              label={t("employeeAwards.form.labels.notesLabel")}
              placeholder={t("employeeAwards.form.placeholders.insertNotes")}
              maxLength={500}
              rules={[
                {
                  required: true,
                  message: t("employeeAwards.form.validation.fieldRequired"),
                },
              ]}
            />
          </Form>
        </Modal>
      </AdnCard>
    </>
  );
};

export default EmployeeAwardsListForm;
